export default __webpack_public_path__ + "static/media/images.62406576.jpg";